module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "pos-relative inline-block"
  }, [_c('button', {
    staticClass: "dropup-button",
    on: {
      "click": _vm.open
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropup"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "dropup-content bg-white large-box-shadow rounded"
  }, [_vm._t("list", function() {
    return [_c('li', [_vm._v("Three")]), _vm._v(" "), _c('li', [_vm._v("Two")]), _vm._v(" "), _c('li', [_vm._v("One")])]
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19b6b987!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DropUp.vue
// module id = 1528
// module chunks = 1